import type { SingleResponseMessage, ArrayOfResponseMessages } from '../../../service';
export type SingleResponseMessageResponse = { Body: SingleResponseMessage };
type BatchResponseMessageResponse = {
    Body: {
        ResponseMessages?: ArrayOfResponseMessages<SingleResponseMessage>;
    };
};

export function isUnsuccessfulResponse<U>(response: U): boolean {
    return (
        isSingleResponseMessageFailureResponse((<{}>response) as SingleResponseMessageResponse) ||
        isBatchResponseFailureResponse((<{}>response) as BatchResponseMessageResponse)
    );
}

export function getUnsuccessfulResponseMessage<U>(response: U): string {
    const singleMessageResponse = (<{}>response) as SingleResponseMessageResponse;
    if (isSingleResponseMessageFailureResponse(singleMessageResponse)) {
        return getSingleResponseFailureMessage((<{}>response) as SingleResponseMessageResponse);
    }

    const batchMessageResponse = (<{}>response) as BatchResponseMessageResponse;
    if (isBatchResponseFailureResponse(batchMessageResponse)) {
        return getBatchResponseFailureResponse(batchMessageResponse);
    }

    return null;
}

export function getUnsuccessfulResponseCode<U>(response: U): string {
    const singleMessageResponse = (<{}>response) as SingleResponseMessageResponse;
    if (isSingleResponseMessageFailureResponse(singleMessageResponse)) {
        return singleMessageResponse.Body.ResponseCode
            ? singleMessageResponse.Body.ResponseCode
            : null;
    }

    return null;
}

function isSingleResponseMessageFailureResponse(response: SingleResponseMessageResponse): boolean {
    return response?.Body?.ResponseClass && response.Body.ResponseClass !== 'Success';
}

function isBatchResponseFailureResponse(response: BatchResponseMessageResponse): boolean {
    return (
        response?.Body?.ResponseMessages?.Items &&
        response.Body.ResponseMessages.Items.every(item => item && item.ResponseClass !== 'Success')
    );
}

function getSingleResponseFailureMessage(response: SingleResponseMessageResponse): string {
    return response.Body.MessageText;
}

function getBatchResponseFailureResponse(response: BatchResponseMessageResponse): string {
    return response.Body.ResponseMessages.Items[0].MessageText;
}
